"use client";

import { navItems } from "@/data";

import Grid from "@/components/Grid";
import Footer from "@/components/Footer";
import Clients from "@/components/Clients";
import Details from "@/components/Details";
import Approach from "@/components/Approach";
import Experience from "@/components/Experience";
import RecentProjects from "@/components/RecentProjects";
import { FloatingNav } from "@/components/ui/FloatingNavbar";
import MultiLayerParallax from "@/components/MultiLayerParallax";

const Home = () => {
  return (
    <main className="relative bg-black-100 flex justify-center items-center flex-col overflow-clip mx-auto sm:px-10 px-5">
      <FloatingNav navItems={navItems} />
      <MultiLayerParallax />
      <div className="max-w-7xl w-full ">
        <Grid />
        <Details />
        <RecentProjects />
        <Experience />
        <Approach />
        <Footer />
      </div>
    </main>
  );
};

export default Home;
